module.exports = __webpack_public_path__ + "img/avatar.75297213.png";